import { EVENT_COLLECTION } from './event';
import { NOTICE_COLLECTION } from './notice';
import { BOARD_COLLECTION } from './board';
import { NOTIFICATIONS_COLLECTION } from './notification';
import { DEVICE_SUBCOLLECTION, DEVICES_COLLECTION, ENTERPRISE_COLLECTION, USER_COLLECTION, USER_EVENT_SUBCOLLECTION } from './user';

// Firestore 컬렉션 타입들
export * from './user';
export * from './enterprise';
export * from './notice';
export * from './event';
export * from './board';
export * from './notification';
export * from './merchant'; // 새로 추가된 Merchant 타입
export * from './merchant-v2'; // MerchantV2 타입
export * from './dashboard'; // 대시보드 통계 타입

// Firestore 컬렉션 경로 상수들
export const COLLECTIONS = {
  USERS: USER_COLLECTION,
  DEVICES: DEVICES_COLLECTION,
  ENTERPRISES: ENTERPRISE_COLLECTION,
  NOTICES: NOTICE_COLLECTION,
  EVENTS: EVENT_COLLECTION,
  BOARDS: BOARD_COLLECTION,
  NOTIFICATIONS: NOTIFICATIONS_COLLECTION,
} as const;

// Firestore 하위 컬렉션 경로 상수들
export const SUBCOLLECTIONS = {
  DEVICE: DEVICE_SUBCOLLECTION,
  USER_EVENT: USER_EVENT_SUBCOLLECTION,
} as const;


export enum PlacementType {
  NONE = 'none',
  TOP_BANNER = 'top_banner',
  BOTTOM_BANNER = 'bottom_banner',
} 